import {LocationAggregate} from '../../../../models/locationaggregate.model';
import {QuoteWizardDefaultViewController} from '../../../quoteWizardDefaultView.controller';

export class HaveLiquorSalesController extends QuoteWizardDefaultViewController {
    public goNext() {
        if (this.isLocationAggregate(this.subject)) {
            const location = this.subject as LocationAggregate;
            const haveLiquorSales: boolean = location.haveLiquorSales;
            // business rule: if haveLiquorSales is false, we explicitly set liquor sales amount to zero to comply with how this field was handled before the quote wizard
            if (haveLiquorSales === false) {
                location.salesLiquor = 0;
            }
        }
        super.goNext();
    }

    private isLocationAggregate(item: any): item is LocationAggregate {
        return (item as LocationAggregate).address !== undefined;
    }
}